import { lazy } from "react";

export const PublicDirectoryPageAsync = lazy(async function () {
  return import("./PublicDirectoryPage").then((m) => ({ default: m.PublicDirectoryPage }));
});
